import React, { useEffect, useRef, useState,createContext} from "react";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";

// Custom Components
import Filter from "components/Filter";
import { DASHBOARD_SUMMARY_URL, URLS } from "configs/constants";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { fetchDataFromApi } from "utils";
import { Card, CardContent, Divider } from "@material-ui/core";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faFirstAid,
  faHeartBroken,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";


const filterFields = [
  {
    type: "datepicker",
    label: "Date",
    name: "date",
  },
];

const today = new Date();
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');
const initialFromDate = "2021-10-01";

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};

export default function AttendanceSummary() {
  
const [selectedFromDate, setSelectedFromDate] = useState(null);
const [selectedtoDate, setSelectedToDate] = useState(null);
const [selectedGrievanceFromDate, setSelectedGrievanceFromDate] = useState(null);
const [selectedGrievancetoDate, setSelectedGrievancetoDate] = useState(null);
const [allChecked, setAllChecked] = useState(false);


const getGrievanceFromDate = (e) => {
  setSelectedGrievanceFromDate(e);
};
const getGrievanceToDate = (e) => {
  setSelectedGrievancetoDate(e);
};

const getFromDate = (e) => {
  setSelectedFromDate(e);
};
const getToDate = (e) => {
  setSelectedToDate(e);
};
  const { t } = useTranslation();
  const colorPallete = [
    "#008d32",
    "#ff883b",
    "#df1e28",
    "#00838f",
    "#6232f9",
    "#d33997",
    "#654806",
  ];
  const filterTwoFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "date_from",
      maxDate:selectedtoDate,
        getValue: getFromDate,
    },
    {
      type: "datepicker",
      label: "To Date",
      name: "date_to",
      minDate: selectedFromDate,
      getValue: getToDate,
    },
  ];
  const grievancefilterTwoFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "date_from",
      maxDate:selectedGrievancetoDate,
        getValue: getGrievanceFromDate,
    },
    {
      type: "datepicker",
      label: "To Date",
      name: "date_to",
      minDate: selectedGrievanceFromDate,
      getValue: getGrievanceToDate,
    },
  ];
  const [dateForAPI, setDateForAPI] = useState(date);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [sosLoading, setSOSLoading] = useState(false);
  const [grievanceLoading, setGrievanceLoading] = useState(false);
  const [sosDateRange, setSosDateRange] = useState({
    dateFrom: initialFromDate,
    dateTo: date,
  });
  const [grievanceDateRange, setGrievanceDateRange] = useState({
    dateFrom: initialFromDate,
    dateTo: date,
  });
  const [summary, setSummary] = useState({});
  const filterInitialValues = {
    date: date,
  };
  const sosFilterInitialValues = {
    date_from: sosDateRange.dateFrom,
    date_to: sosDateRange.dateTo,
  };
  const grievanceFilterInitialValues = {
    date_from: sosDateRange.dateFrom,
    date_to: sosDateRange.dateTo,
  };
  const classes = useStyles();

  const apiCallback = (data) => {
    let results = {};
    if (data.attendance) {
      results["attendance"] = data.attendance;
      setAttendanceLoading(false);
    }
    if (data.sos) {
      results["sos"] = data.sos;
      setSOSLoading(false);
    }
    if (data.grievance) {
      results["grievance"] = data.grievance;
      setGrievanceLoading(false);
    }
    setSummary({ ...summary, ...results });
  };

  useDidMountEffect(() => {
    setAttendanceLoading(true);
    fetchDataFromApi(
      DASHBOARD_SUMMARY_URL + "?date=" + dateForAPI + "&attendance=True",
      apiCallback,
      false
    );
  }, [dateForAPI]);

  useDidMountEffect(() => {
    setSOSLoading(true);
    let url =
      DASHBOARD_SUMMARY_URL +
      "?date_from=" +
      sosDateRange.dateFrom +
      "&date_to=" +
      sosDateRange.dateTo +
      "&sos=True";
    if (sosDateRange.dateFrom && sosDateRange.dateTo) {
      fetchDataFromApi(url, apiCallback, false);
    }
  }, [sosDateRange.dateFrom, sosDateRange.dateTo, sosDateRange]);

  useDidMountEffect(() => {
    setGrievanceLoading(true);
    let url =
      DASHBOARD_SUMMARY_URL +
      "?date_from=" +
      grievanceDateRange.dateFrom +
      "&date_to=" +
      grievanceDateRange.dateTo +
      "&grievance=True";
    if (grievanceDateRange.dateFrom && grievanceDateRange.dateTo) {
      fetchDataFromApi(url, apiCallback, false);
    }
  }, [
    grievanceDateRange.dateFrom,
    grievanceDateRange.dateTo,
    grievanceDateRange,
  ]);

  useEffect(() => {
    fetchDataFromApi(
      DASHBOARD_SUMMARY_URL + "?sos=True&grievance=True&attendance=True",
      apiCallback,
      false
    );
  }, []);

  const handleSubmit = (values) => {
    setDateForAPI(values.date);
    
  };

  
  const handleSubmitForSosDateRange = (values) => {
    setSosDateRange({
      ...sosDateRange,
      dateFrom: values.date_from,
      dateTo: values.date_to,
    });

  };

  const handleSubmitForGrievanceDateRange = (values) => {
    setGrievanceDateRange({
      ...grievanceDateRange,
      dateFrom: values.date_from,
      dateTo: values.date_to,
    });
  };
  const onclearFilter = () => {
    setAllChecked(false);
  };

  return (
    <div>
      <div>
        {summary.attendance ? (
          <div>
            <Filter
              noClearButton
              initialValues={filterInitialValues}
              filterFields={filterFields}
              onSubmit={handleSubmit}
              onClear={onclearFilter}

            />
            {attendanceLoading ? (
              <LoadingIcon text="Loading" />
            ) : (
              <Paper
                className={classes.filterPaper}
                variant="outlined"
                style={{ padding: "20px" }}
              >
                <Typography paragraph variant="h5" color="textPrimary">
                  <FontAwesomeIcon fixedWidth icon={faQrcode} color="red" />
                  {" " + t("Attendance Summary")}
                </Typography>
                <Divider />
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justify="flex-start"
                >
                  {summary.attendance.map((sum, index) => {
                    return (
                      <Grid
                        key={index}
                        container
                        justify="center"
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                      >
                        <Link
                       
                          to={{
                          pathname: URLS.ATTENDANCE_LIST,
                            searchParams: {
                              from_date: { dateForAPI },
                              to_date: { dateForAPI },
                              status: sum.value,
                            },
                          }}
                        >
                          <Card
                            value={sum}
                            style={{
                              borderRadius: "10px",
                              backgroundColor: colorPallete[index],
                              display: "block",
                              width: "200px",
                              textAlign: "center",
                            }}
                            className={classes.card}
                          >
                            <CardContent>

                              <Typography
                             
                                variant="h6"
                                color="secondary"
                                component="p"
                              >
                                {sum.count}
                              </Typography>
                              <Typography
                                variant="body1"
                                color="secondary"
                                component="p"
                              >
                                {t(sum.name)}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Link>
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            )}
          </div>
        ) : null}
        <br></br>
        {summary.sos ? (
          <div>
            <Filter
              noClearButton
              initialValues={sosFilterInitialValues}
              filterFields={filterTwoFields}
              onSubmit={handleSubmitForSosDateRange}
              onClear={onclearFilter}

            />
            {sosLoading ? (
              <LoadingIcon text="Loading" />
            ) : (
              <Paper
                className={classes.filterPaper}
                variant="outlined"
                style={{ padding: "20px" }}
              >
                <Typography paragraph variant="h5" color="textPrimary">
                  <FontAwesomeIcon fixedWidth icon={faFirstAid} color="red" />
                  {" " + t("SOS Summary")}
                </Typography>
                <Divider />
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justify="flex-start"
                >
                  {summary.sos.map((sum, index) => {
                    return (
                      <Grid
                        key={index}
                        container
                        justify="center"
                        wrap="wrap"
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                      >
                        <Link
                          to={{
                            pathname: URLS.SOS_LIST,
                            filters: {
                              date_from: sosDateRange.dateFrom,
                              date_to: sosDateRange.dateTo,
                              status: sum.value,
                            },
                          }}
                        >
                          <Card
                          
                          value={sum}
                            style={{
                              borderRadius: "10px",
                              backgroundColor: colorPallete[index],
                              display: "block",
                              width: "200px",
                              textAlign: "center",
                            }}
                            className={classes.card}
                          >
                            <CardContent>
                              <Typography
                                variant="h6"
                                color="secondary"
                                component="p"
                              >
                                {sum.count}
                              </Typography>
                              <Typography
                                variant="body1"
                                color="secondary"
                                component="p"
                              >
                                {t(sum.name)}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Link>
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            )}
          </div>
        ) : null}
        <br></br>

        {summary.grievance ? (
          <div>
            <Filter
              noClearButton
              initialValues={grievanceFilterInitialValues}
              filterFields={grievancefilterTwoFields}
              onSubmit={handleSubmitForGrievanceDateRange}
              
            />
            {grievanceLoading ? (
              <LoadingIcon text="Loading" />
            ) : (
              <Paper
                className={classes.filterPaper}
                variant="outlined"
                style={{ padding: "20px" }}
              >
                <Typography paragraph variant="h5" color="textPrimary">
                  <FontAwesomeIcon
                    fixedWidth
                    icon={faHeartBroken}
                    color="red"
                  />
                  {" " + t("Grievance Summary")}
                </Typography>
                <Divider />
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justify="flex-start"
                >
                  {summary.grievance.map((sum, index) => {
                    return (
                      <Grid
                        key={index}
                        container
                        justify="space-evenly"
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                      >
                        <Link
                          to={{
                            pathname: URLS.GRIEVANCE_LIST,
                            filters: {
                              date_from: grievanceDateRange.dateFrom,
                              date_to: grievanceDateRange.dateTo,
                              status: sum.value,
                            },
                          }}
                        >
                          <Card
                          value={sum}
                            style={{
                              borderRadius: "10px",
                              backgroundColor: colorPallete[index],
                              display: "block",
                              width: "200px",
                              textAlign: "center",
                            }}
                            className={classes.card}
                          >
                            <CardContent>
                              <Typography
                                variant="h6"
                                color="secondary"
                                component="p"
                              >
                                {sum.count}
                              </Typography>
                              <Typography
                                variant="body1"
                                color="secondary"
                                component="p"
                              >
                                {t(sum.name)}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Link>
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}
